<template>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4>
        <v-menu
          ref="menuStart"
          :close-on-content-click="false"
          v-model="menuStart"
          :nudge-right="40"
          :return-value.sync="dateStart"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateStart"
              label="Fecha inicial"
              prepend-icon="event"
              readonly
              v-on="on"
              :rules="dateRules"
            ></v-text-field>
          </template>
          <v-date-picker 
            v-model="dateStart" 
            :min="minDate"
            :max="maxDate"
            @input="$refs.menuStart.save(dateStart)"
            locale="es-ES"
          ></v-date-picker>
        </v-menu>
      </v-flex>
  
      <v-flex xs12 sm6 md4>
        <v-menu
          ref="menuEnd"
          :close-on-content-click="false"
          v-model="menuEnd"
          :nudge-right="40"
          :return-value.sync="dateEnd"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateEnd"
              label="Fecha final"
              prepend-icon="event"
              readonly
              v-on="on"
              :rules="dateRules"
            ></v-text-field>
          </template>
          <v-date-picker 
            v-model="dateEnd"
            :min="dateStart || minDate"
            :max="maxDate"
            @input="$refs.menuEnd.save(dateEnd)"
            locale="es-ES"
          ></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </template>
  
  <script>
  import moment from "moment";
  export default {
    name: 'DateRangePicker',
    data: () => ({
      dateStart: null,
      dateEnd: null,
      menuStart: false,
      menuEnd: false,
      minDate: '2020-01-01', // Puedes ajustar esta fecha según tus necesidades
      //maxDate: moment(new Date(), 'YYYY-MM-DD').format('DD-MM-YYYY'), // Puedes ajustar esta fecha según tus necesidades
      dateRules: [
        v => !!v || 'La fecha es requerida'
      ]
    }),
    watch: {
      dateStart(val) {
        // Validar que la fecha final no sea menor que la inicial
        if (this.dateEnd && val > this.dateEnd) {
          this.dateEnd = val;
        }
        this.$emit('update:dateRange', {
          start: this.dateStart,
          end: this.dateEnd
        });
      },
      dateEnd(val) {
        this.$emit('update:dateRange', {
          start: this.dateStart,
          end: this.dateEnd
        });
      }
    },
    methods: {
      // Método para limpiar las fechas si es necesario
      clearDates() {
        this.dateStart = null;
        this.dateEnd = null;
      }
    }
  }
  </script>